import { format } from "date-fns";

export const formatDate = (date, formatString = "d MMM y") =>
  format(new Date(date), formatString);
